import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';

@Pipe({
  name: 'underlined'
})
export class UnderlinedPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, text: string) {

    let palabras: string[];
    let newValue: string;
    let valIgnoreCase: string;

    text = _.trim(text);
    newValue = value;

    if (text) {

      // valIgnoreCase = value.toLowerCase().replace('ó', 'o');
      // palabras = text.toLowerCase().replace('ó', 'o').split(' ');

      valIgnoreCase = value.toLowerCase();
      palabras = text.toLowerCase().split(' ');

      _.each(palabras, palabra => {

        const indice = valIgnoreCase.indexOf(palabra);

        if (indice >= 0) {
          newValue = newValue.replace(new RegExp(palabra, 'ig'), function (x) { return '<span>' + x + '</span>'; } );

        }

      });
    }

    return this.sanitizer.bypassSecurityTrustHtml(newValue);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pipes/underlined.pipe.ts